"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Mixin_1 = require("auto-widget-framework/src/Util/Mixin");
const IContainerInjection_1 = require("auto-widget-framework/src/Container/IContainerInjection");
const EventEmitter = require("events");
const FormValidatorTypes_1 = require("../../Enum/FormValidatorTypes");
const FormValidationRendererTypes_1 = require("../../Enum/FormValidationRendererTypes");
const QuestionnaireForm_1 = require("../../Plugin/FormHandler/QuestionnaireForm");
/**
 * Mixed (base and questionnaire) Form handler base plugin.
 */
class MixedFormHandler extends QuestionnaireForm_1.default {
    constructor(definition, formElement, formValidatorFactory, formValidationRendererFactory, formValuesToObjectTransformer, scrollInView) {
        super(definition, formElement, formValidatorFactory, formValidationRendererFactory, formValuesToObjectTransformer, scrollInView);
        this.formValuesToObjectTransformer = formValuesToObjectTransformer;
    }
    /**
     * @inheritDoc
     */
    static create(definition, formElement, container) {
        return new this(definition, formElement, container.get("factory.form_validator"), container.get("factory.form_validation_renderer"), container.get("transformer.form_values_to_object"), container.get("scroll_in_view"));
    }
    /**
     * Gets the form validator.
     */
    getFormValidator() {
        if (this.getValidationConfig()) {
            return this.formValidatorFactory
                .create(FormValidatorTypes_1.FormValidatorTypes.MIXED, {
                form: this.getFormElement(),
                config: this.getValidationConfig(),
                questionnaire: this.questionnaires
            });
        }
        else {
            return this.formValidatorFactory.create(FormValidatorTypes_1.FormValidatorTypes.NULL);
        }
    }
    /**
     * Gets the renderer for form errors.
     */
    getFormValidationRenderer() {
        if (this.getValidationConfig()) {
            return this.formValidationRendererFactory
                .create(FormValidationRendererTypes_1.FormValidationRendererTypes.MIXED, {
                form: this.getFormElement(),
                config: this.getValidationConfig(),
                questionnaire: this.questionnaires
            });
        }
        else {
            return this.formValidationRendererFactory.create(FormValidationRendererTypes_1.FormValidationRendererTypes.NULL);
        }
    }
    /**
     * @inheritDoc
     */
    submit(values, action = "default") {
        const questionnaireValues = {};
        this.questionnaires[0].getQuestions().forEach((question) => {
            if (values[question.getId()] !== undefined) {
                questionnaireValues[question.getId()] = values[question.getId()];
                delete values[question.getId()];
            }
        });
        return super.submit({
            questionnaire: questionnaireValues,
            extra: values,
        }, action);
    }
}
exports.default = MixedFormHandler;
Mixin_1.default(MixedFormHandler, EventEmitter, IContainerInjection_1.default);
